import { gateway } from "../../../../gateway";

export const postVisit = async (payload) => {
  try {
    const token = sessionStorage.getItem("token");

    const res = await gateway.post(
      "jobs/visits",
      payload,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    return res.data || res.data?.data;
  } catch (error) {
    throw error;
  }
};
